import { connect } from 'react-redux'
import { apiService } from 'services'

const props = state => ({
    works: state.works
})

const services = {
    ...apiService
}

export default cmp => connect( props, services )( cmp )